module.exports = __webpack_public_path__ + "static/media/achievement-2.0192dc76.png";